export const STAGE__WIDTH = 12;
export const STAGE__HEIGHT = 20;


//Create stage array
export const createStage = () => 
  Array.from(Array(STAGE__HEIGHT), () =>
    Array(STAGE__WIDTH).fill([0, 'clear'])
  )

// check collision - boolean return
  export const checkCollision = (player, stage, {x: moveX, y: moveY}) => {

      for(let y = 0; y < player.tetromino.length; y+=1) {
        for(let x = 0; x < player.tetromino[y].length; x+=1) {
          if(player.tetromino[y][x] !== 0) {
           if(!stage[y + player.pos.y + moveY] ||
             !stage[y + player.pos.y + moveY][x + player.pos.x + moveX]
             || stage[y + player.pos.y + moveY][x + player.pos.x + moveX][1] !== 'clear') {
             return true;
           }
          }
        }
      }
      return false;
  }
